import './vendor/swiper';
import './vendor/choices';
